import { render, staticRenderFns } from "./ViewCourse.vue?vue&type=template&id=775db1d0&scoped=true"
import script from "./ViewCourse.vue?vue&type=script&lang=js"
export * from "./ViewCourse.vue?vue&type=script&lang=js"
import style0 from "./ViewCourse.vue?vue&type=style&index=0&id=775db1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775db1d0",
  null
  
)

export default component.exports